import { InfoIcon } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent } from '../tooltip';
import { type ReactNode } from 'react';
import { cn } from '../../cn';

export function InfoTooltip({
  content,
  className,
}: {
  content: ReactNode;
  className?: string;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <InfoIcon className="w-4 h-4 ml-2 text-muted-foreground cursor-pointer" />
      </TooltipTrigger>
      <TooltipContent
        className={cn('bg-neutral-900 text-neutral-50 z-[100]', className)}
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
